import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BOLD_FONT_FAMILY } from '../constants/constants';
import { ROOM_NAME_HYPERLINK_COLOR } from './colors';
export const Form = styled.form `
  display: flex;
  flex-direction: column;
  padding: 15px;
  gap: 2px;
`;
export const PANEL_CONTENT_WITHOUT_TEXT_HEADER_PADDING_STRING = '5px 0 5px 5px';
/**
 * Assumes there is a text header labeling the panel at the top.
 */
export const PANEL_CONTENT_PADDING_STRING = '0 0 5px 5px';
export const PANEL_FRAMELESS_CONTENT_PADDING_STRING = '0';
export const ROOM_NAME_HYPERLINK_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
  color: ${ROOM_NAME_HYPERLINK_COLOR};
  letter-spacing: -0.5px;
`;
